import gql from 'graphql-tag';

export default gql`
  query AnnouncementAudienceSizesQuery($locationId: ID!) {
    announcementAudienceSizes(locationId: $locationId) {
      locationId
      employeeAudienceCount {
        allEmployeesAtDefaultLocation
        allEmployeesAtLocation
        allEmployeesCheckedIn
        allEmployeesWithReservation
        self
      }
      visitorAudienceCount {
        allVisitorsCheckedIn
        allVisitorsSignedOut
        allVisitorsWithReservation
      }
    }
  }
`;
